
import React from "react";
import './footer.css';

function Footer(){
    return(

    <div class="footer">
  <p>All Rights Reserved by @Mohit Sharma.</p>
  <div class="social">
<a href="https://www.facebook.com/themohitgaur5/" class="fa fa-facebook"></a>
<a href="https://twitter.com/themohitgaur1" class="fa fa-twitter"></a>
<a href="https://www.linkedin.com/in/mohit-sharma-478603115/" class="fa fa-linkedin"></a>
<a href="https://github.com/themohitgaur" class="fa fa-github"></a>
<a href="https://www.instagram.com/themohitgaur/" class="fa fa-instagram"></a>
  </div>
</div>
    )
}

export default Footer;